import { Injectable, inject } from '@angular/core';
import * as Sentry from '@sentry/angular';
import { AppService } from 'src/app/app.service';
import { EnvironmentService } from '../environment/environment.service';

@Injectable({
  providedIn: 'root',
})
export class SentryErrorService {
  constructor(private envService: EnvironmentService) {}

  appService = inject(AppService);

  initSentry() {
    Sentry.init({
      dsn: 'https://6ae37f4cbfc669db12ed3ddf8b5f6476@o46994.ingest.sentry.io/4507327360008192',
      release: this.envService.version,
      environment: this.envService.env,
      beforeSend: (event, hint) => this.sentryBeforeSend(event, hint),
    });
  }

  sentryBeforeSend(event, hint) {
    if (this.envService.isLocal) {
      return null;
    }

    if (!event.tags) event.tags = {};

    event.tags.tenant = this.appService.tenant;

    return event;
  }
}
